import * as angular from 'angular';


export class AncillariesInsuranceTransformer {
    constructor (
        private CurrencyService: CurrencyService
    ) {}

    generateInsuranceInfo = (insuranceInfo: any, transformedInsuranceInfo: any, copyCurrency: any) => {
        transformedInsuranceInfo.countriesList = insuranceInfo.countriesAllowed;
        transformedInsuranceInfo.priceZero = this.CurrencyService.formatPrice(copyCurrency, 0, true, false);
        transformedInsuranceInfo.priceFrom = this.CurrencyService.formatPrice(copyCurrency, insuranceInfo.offers[0].premium, true, false);
        transformedInsuranceInfo.conditionsUri = insuranceInfo.offers[0].termsAndConditionsDocumentURI;
        transformedInsuranceInfo.id = insuranceInfo.offers[0].code;
        transformedInsuranceInfo.consent = insuranceInfo.offers[0].consent;
    };
}

AncillariesInsuranceTransformer.$inject = ['CurrencyService'];
try {
    const mod = angular.module('ib-web-ancillaries-module');
    mod.service('AncillariesInsuranceTransformer', AncillariesInsuranceTransformer);
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-module', []);
    mod.service('AncillariesInsuranceTransformer', AncillariesInsuranceTransformer);
}
